/* Aarwaan product page motion. Loaded only by the product section (aw-product-main).
   Adds visuals to the existing sections; it never changes their text or order.
   Note: on desktop the Horizon theme scrolls .page-wrapper, not the window, so every
   scroll listener here is a capturing listener on document, which hears both. */
(function () {
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  html.classList.add('aw-pdp-page');
  if (!reduce) html.classList.add('aw-motion');

  function $$(sel, root) { return [].slice.call((root || d).querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function onScroll(fn) {
    var tick = false;
    function run() { tick = false; fn(); }
    function req() { if (!tick) { tick = true; requestAnimationFrame(run); } }
    d.addEventListener('scroll', req, { passive: true, capture: true });
    window.addEventListener('resize', req);
    fn();
  }
  function safePlay(v) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function inView(el, fn, opts) {
    if (!('IntersectionObserver' in window)) { fn(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting, e); }); }, opts || { threshold: 0.2 }).observe(el);
  }

  /* Elements with data-aw-reveal get .is-in once they scroll into view */
  function reveal(root) {
    $$('[data-aw-reveal]', root).forEach(function (el) {
      if (!once(el, 'awRev')) return;
      if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      io.observe(el);
    });
  }

  /* Silent loops (gallery texture, mobile step clips) play only while visible */
  function videos(root) {
    if (reduce) return;
    $$('video[data-aw-play]', root).forEach(function (v) {
      if (!once(v, 'awVid')) return;
      if (v.closest('.aw-stage-item')) return; /* the pinned step stage controls its own videos */
      inView(v, function (vis) { if (vis) safePlay(v); else v.pause(); }, { threshold: 0.35 });
    });
  }

  /* 1. Gallery zoom lens */
  function lens(root) {
    if (!fine) return;
    $$('[data-aw-zoom]', root).forEach(function (fig) {
      if (!once(fig, 'awLens')) return;
      var img = fig.querySelector('img');
      if (!img) return;
      var l = d.createElement('span');
      l.className = 'aw-lens';
      l.setAttribute('aria-hidden', 'true');
      fig.appendChild(l);
      var loaded = false, Z = 2.3;
      fig.addEventListener('mouseenter', function () {
        if (!loaded) { l.style.backgroundImage = 'url("' + fig.dataset.awZoom + '")'; loaded = true; }
        fig.classList.add('lens-on');
      });
      fig.addEventListener('mouseleave', function () { fig.classList.remove('lens-on'); });
      fig.addEventListener('mousemove', function (e) {
        var r = fig.getBoundingClientRect();
        var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
        var cover = Math.max(r.width / nw, r.height / nh);
        var dw = nw * cover, dh = nh * cover, ox = (r.width - dw) / 2, oy = (r.height - dh) / 2;
        var x = e.clientX - r.left, y = e.clientY - r.top, s = l.offsetWidth / 2;
        l.style.transform = 'translate(' + (x - s) + 'px,' + (y - s) + 'px)';
        l.style.backgroundSize = (dw * Z) + 'px ' + (dh * Z) + 'px';
        l.style.backgroundPosition = (-((x - ox) * Z - s)) + 'px ' + (-((y - oy) * Z - s)) + 'px';
      });
    });
  }

  /* 5. Steps: active step follows the scroll, the pinned visual and its clip change with it */
  function steps(root) {
    $$('[data-aw-steps].has-media', root).forEach(function (w) {
      if (!once(w, 'awSteps')) return;
      var list = w.querySelector('.aw-steps');
      var items = $$('.aw-steps > li', w);
      var stage = $$('.aw-stage-item', w);
      var count = w.querySelector('[data-aw-stage-n]');
      var stageEl = w.querySelector('.aw-steps-stage');
      var cur = -1, stageVisible = false;
      function stageShown() { return stageEl && stageEl.offsetParent !== null && stageVisible; }
      function setActive(i) {
        items.forEach(function (li, k) { li.classList.toggle('on', k === i); });
        stage.forEach(function (s, k) {
          s.classList.toggle('on', k === i);
          var v = s.querySelector('video');
          if (!v || reduce) return;
          if (k === i && stageShown()) { try { v.currentTime = 0; } catch (e) {} safePlay(v); } else v.pause();
        });
        if (count) count.textContent = i + 1;
      }
      if (stageEl) inView(stageEl, function (vis) { stageVisible = vis; setActive(Math.max(cur, 0)); }, { threshold: 0.1 });

      /* The text scrolls normally; the picture stays put (CSS sticky) under the header.
         The list has extra room after step 3 (CSS), so step 3 is fully shown
         before the picture lets go and the next section comes up. */
      function pinTop() {
        var h = d.querySelector('#header-group');
        var t = h ? Math.max(0, Math.min(h.getBoundingClientRect().bottom, 140)) : 90;
        w.style.setProperty('--aw-pin-top', Math.round(t + 16) + 'px');
      }

      onScroll(function () {
        pinTop();
        var best = 0;
        var mid = window.innerHeight * 0.55;
        items.forEach(function (li, k) {
          var rr = li.getBoundingClientRect();
          if (rr.top + rr.height * 0.5 < mid) best = k;
        });
        var first = items[0].getBoundingClientRect(), last = items[items.length - 1].getBoundingClientRect();
        var span = (last.top + last.height * 0.5) - (first.top + first.height * 0.5);
        var p = Math.min(1, Math.max(0, (mid - (first.top + first.height * 0.5)) / Math.max(span, 1)));
        if (best !== cur) { cur = best; setActive(best); }
        if (!reduce) list.style.setProperty('--aw-p', p.toFixed(3));
      });
    });
  }

  /* 6. Ingredient cards: picture and name first, details open on hover or tap */
  function ings(root) {
    $$('[data-aw-ing]', root).forEach(function (c) {
      if (!once(c, 'awIng')) return;
      var b = c.querySelector('.aw-ing-btn');
      if (!b) return;
      b.hidden = false;
      c.classList.add('is-collapsible');
      function set(open) { c.classList.toggle('open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      b.addEventListener('click', function (e) { e.stopPropagation(); set(!c.classList.contains('open')); });
      if (fine) {
        c.addEventListener('mouseenter', function () { set(true); });
        c.addEventListener('mouseleave', function () { set(false); });
      } else {
        c.addEventListener('click', function () { set(!c.classList.contains('open')); });
      }
    });
  }

  /* 7. Reviews: the rating counts up, cards sit in a 3D deck that shuffles itself */
  function ticker(root) {
    $$('[data-aw-ticker]', root).forEach(function (el) {
      if (!once(el, 'awTick')) return;
      var to = parseFloat(el.dataset.awTicker) || 0;
      function fmt(n) { return n.toFixed(1).replace('.', ','); }
      if (reduce) { el.textContent = fmt(to); return; }
      el.textContent = fmt(0);
      var host = el.closest('[data-aw-reveal]') || el;
      inView(host, function (vis) {
        if (!vis || el.dataset.awTicked) return;
        el.dataset.awTicked = '1';
        var t0 = performance.now(), dur = 1400;
        (function frame(t) {
          var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = fmt(to * e);
          if (k < 1) requestAnimationFrame(frame);
        })(t0);
      });
    });
  }
  function deck(root) {
    $$('[data-aw-deck]', root).forEach(function (dk) {
      if (!once(dk, 'awDeck')) return;
      var cards = $$('.aw-rv', dk);
      if (cards.length < 2) return;
      var wrap = dk.querySelector('.aw-deck-cards');
      var nav = dk.querySelector('.aw-deck-nav');
      var nEl = dk.querySelector('[data-aw-deck-n]');
      var order = cards.map(function (_, i) { return i; });
      var busy = false, timer = null, visible = false, hover = false;
      dk.classList.add('is-deck');
      if (nav) nav.hidden = false;
      function size() {
        var h = 0;
        cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
        wrap.style.setProperty('--deck-h', (h + 60) + 'px');
      }
      function paint() {
        order.forEach(function (ci, pos) { cards[ci].dataset.pos = Math.min(pos, 3); cards[ci].setAttribute('aria-hidden', pos === 0 ? 'false' : 'true'); });
        if (nEl) nEl.textContent = order[0] + 1;
      }
      function go(dir) {
        if (busy) return;
        busy = true;
        if (dir > 0) {
          var top = cards[order[0]];
          top.classList.add('is-out');
          setTimeout(function () {
            order.push(order.shift());
            top.classList.remove('is-out');
            paint();
            busy = false;
          }, reduce ? 0 : 520);
        } else {
          order.unshift(order.pop());
          var back = cards[order[0]];
          back.classList.add('is-out', 'is-out-left');
          paint();
          requestAnimationFrame(function () { requestAnimationFrame(function () { back.classList.remove('is-out', 'is-out-left'); busy = false; }); });
        }
      }
      function schedule() {
        clearInterval(timer);
        if (reduce) return;
        timer = setInterval(function () { if (visible && !hover && !d.hidden) go(1); }, 5200);
      }
      var prev = dk.querySelector('[data-aw-deck-prev]'), next = dk.querySelector('[data-aw-deck-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); schedule(); });
      if (next) next.addEventListener('click', function () { go(1); schedule(); });
      dk.addEventListener('mouseenter', function () { hover = true; });
      dk.addEventListener('mouseleave', function () { hover = false; var c = cards[order[0]]; c.style.removeProperty('--rx'); c.style.removeProperty('--ry'); });
      if (fine && !reduce) {
        wrap.addEventListener('mousemove', function (e) {
          var c = cards[order[0]], r = c.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          c.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
          c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
        });
      }
      var sx = null;
      wrap.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      wrap.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); schedule(); }
      });
      dk.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(1); schedule(); }
        if (e.key === 'ArrowLeft') { go(-1); schedule(); }
      });
      inView(dk, function (vis) { visible = vis; }, { threshold: 0.3 });
      paint(); size();
      window.addEventListener('resize', size);
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(size);
      schedule();
    });
  }

  /* 8. FAQ chat: her question appears, the team types, the answer pops in */
  function chat(root) {
    $$('[data-aw-chat]', root).forEach(function (box) {
      if (!once(box, 'awChat')) return;
      var src = box.querySelector('[data-aw-chat-src]');
      var log = box.querySelector('[data-aw-chat-log]');
      var qs = box.querySelector('[data-aw-chat-qs]');
      var items = $$('details', src).map(function (dt) {
        var s = dt.querySelector('summary').cloneNode(true);
        $$('.aw-pm', s).forEach(function (n) { n.remove(); });
        return { q: s.textContent.trim(), a: dt.querySelector('.aw-ans').innerHTML };
      });
      if (!items.length) return;
      box.classList.add('is-chat');
      log.hidden = false; qs.hidden = false;
      var busy = false;
      function scrollLog() { log.scrollTop = log.scrollHeight; }
      function add(cls, htmlStr) {
        var m = d.createElement('div'); m.className = cls; m.innerHTML = htmlStr; log.appendChild(m); scrollLog(); return m;
      }
      function ask(i, btn) {
        if (busy) return;
        busy = true;
        var q = add('aw-msg-q', '');
        q.textContent = items[i].q;
        if (btn) btn.classList.add('is-asked');
        var wait = reduce ? 0 : 450;
        setTimeout(function () {
          var t = reduce ? null : add('aw-msg-typing', '<i></i><i></i><i></i>');
          setTimeout(function () {
            if (t) t.remove();
            add('aw-msg-a', items[i].a);
            busy = false;
          }, reduce ? 0 : 1100);
        }, wait);
      }
      var btns = items.map(function (it, i) {
        var b = d.createElement('button');
        b.type = 'button';
        b.textContent = it.q;
        b.addEventListener('click', function () { ask(i, b); });
        qs.appendChild(b);
        return b;
      });
      if (box.dataset.autoplay === 'true') {
        inView(box, function (vis) {
          if (vis && !box.dataset.awAuto) { box.dataset.awAuto = '1'; setTimeout(function () { ask(0, btns[0]); }, reduce ? 0 : 500); }
        }, { threshold: 0.4 });
      }
    });
  }

  /* 9. Brand promise: words sharpen and light up with the scroll, the seal turns */
  function promise(root) {
    $$('[data-aw-promise]', root).forEach(function (sec) {
      if (!once(sec, 'awPromise')) return;
      var q = sec.querySelector('[data-aw-words]');
      var ring = sec.querySelector('.aw-seal-ring');
      var mark = sec.querySelector('.aw-seal-mark');
      var parts = q.textContent.trim().split(/(\s+)/);
      q.textContent = '';
      parts.forEach(function (t) {
        if (!t) return;
        if (/^\s+$/.test(t)) { q.appendChild(d.createTextNode(' ')); return; }
        var s = d.createElement('span'); s.className = 'w'; s.textContent = t; q.appendChild(s);
      });
      var words = $$('.w', q);
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); sec.classList.add('is-done'); return; }
      onScroll(function () {
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        var pinned = r.height > vh * 1.5;
        var p = pinned ? (-r.top) / (r.height - vh) : (vh * 0.8 - r.top) / (r.height * 0.9);
        p = Math.min(1, Math.max(0, pinned ? p * 1.25 : p));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
        sec.classList.toggle('is-done', n >= words.length);
        if (ring) ring.style.setProperty('--seal', (p * 200) + 'deg');
        if (mark) mark.style.setProperty('--mark', (0.85 + p * 0.25).toFixed(3));
      });
    });
  }

  /* "Passt dazu": the hover preview tilts with mouse movement */
  function tilt() {
    if (!fine || reduce || tilt.done) return;
    tilt.done = true;
    var lx = null, ly = null, t;
    d.addEventListener('mousemove', function (e) {
      var pk = d.querySelector('body > .aw-peek.on');
      if (!pk) { lx = ly = null; return; }
      if (lx !== null) {
        pk.style.setProperty('--aw-ry', Math.max(-14, Math.min(14, (e.clientX - lx) * 1.1)) + 'deg');
        pk.style.setProperty('--aw-rx', Math.max(-10, Math.min(10, -(e.clientY - ly) * 1.1)) + 'deg');
      }
      lx = e.clientX; ly = e.clientY;
      clearTimeout(t);
      t = setTimeout(function () { pk.style.setProperty('--aw-ry', '0deg'); pk.style.setProperty('--aw-rx', '0deg'); }, 140);
    }, { passive: true });
  }

  function init(root) {
    reveal(root); videos(root); lens(root); steps(root); ings(root);
    ticker(root); deck(root); chat(root); promise(root); tilt();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
